// import React from 'react';
// import styles from './UserManagement.module.css';

// const UserPagination = ({
//     currentPage,
//     totalPages,
//     rowsPerPage,
//     totalRecords,
//     onPageChange,
//     onRowsPerPageChange
// }) => {
//     return (
//         <div className={styles.pagination}>
//             <div className={styles.rowsPerPage}>
//                 <span>Rows per page</span>
//                 <select className={styles.rowsSelect} value={rowsPerPage} onChange={onRowsPerPageChange}>
//                     <option value={10}>10</option>
//                     <option value={25}>25</option>
//                     <option value={50}>50</option>
//                     <option value={100}>100</option>
//                 </select>
//             </div>
//             <div className={styles.pageInfo}>Page {currentPage} of {totalPages || 1} ({totalRecords} total)</div>
//             <div className={styles.pageControls}>
//                 <button className={styles.pageButton} onClick={() => onPageChange(1)} disabled={currentPage === 1}>««</button>
//                 <button className={styles.pageButton} onClick={() => onPageChange(Math.max(1, currentPage - 1))} disabled={currentPage === 1}>‹</button>
//                 <button className={styles.pageButton} onClick={() => onPageChange(Math.min(totalPages, currentPage + 1))} disabled={currentPage === totalPages}>›</button>
//                 <button className={styles.pageButton} onClick={() => onPageChange(totalPages)} disabled={currentPage === totalPages}>»»</button>
//             </div>
//         </div>
//     );
// };

// export default UserPagination;

import React from 'react';
import styles from './UserManagement.module.css';

const UserPagination = ({
    currentPage,
    totalPages,
    rowsPerPage,
    totalRecords,
    onPageChange,
    onRowsPerPageChange
}) => {
    return (
        <div className={styles.pagination}>
            <div className={styles.rowsPerPage}>
                <span>Rows per page</span>
                <select className={styles.rowsSelect} value={rowsPerPage} onChange={onRowsPerPageChange}>
                    <option value={10}>10</option>
                    <option value={25}>25</option>
                    <option value={50}>50</option>
                    <option value={100}>100</option>
                </select>
            </div>
            <div className={styles.pageInfo}>Page {currentPage} of {totalPages || 1} ({totalRecords} total)</div>
            <div className={styles.pageControls}>
                <button className={styles.pageButton} onClick={() => onPageChange(1)} disabled={currentPage === 1}>««</button>
                <button className={styles.pageButton} onClick={() => onPageChange(Math.max(1, currentPage - 1))} disabled={currentPage === 1}>‹</button>
                <button className={styles.pageButton} onClick={() => onPageChange(Math.min(totalPages, currentPage + 1))} disabled={currentPage === totalPages}>›</button>
                <button className={styles.pageButton} onClick={() => onPageChange(totalPages)} disabled={currentPage === totalPages}>»»</button>
            </div>
        </div>
    );
};

export default UserPagination;